const DeviceParam = () => import('Views/deviceParam/device-param');

export default[
  { path: '/device-param', component: DeviceParam },
];



// WEBPACK FOOTER //
// ./src/router/deviceParam.js